import React, { useState, useEffect } from 'react'
import './ConfigReview.css'
import 'devextreme/dist/css/dx.common.css'
import 'devextreme/dist/css/dx.light.css'
import Editor from 'react-simple-code-editor'
import { highlight, languages } from 'prismjs'
import { DefaultState } from '../../../types'
import { useSelector, useDispatch } from 'react-redux'
import { getConfigs, getConfigFile } from '../../../redux/slices'
import { AppDispatch } from '../../../services/lib'
import { ConfigFileResponse } from '../../../types/configs/configs'

function ConfigReview(props) {
  const dispatch: AppDispatch = useDispatch()
  const [data, setData] = useState<string>('')
  const [file, setFile] = useState<string>('')

  const selectedConfig = useSelector((state: DefaultState) => state.configs)

  async function urltoFile(url: string, mimeType) {
    const res = await fetch(`${url}`)
    const buf = await res.arrayBuffer()
    return new File([buf], 'Config', { type: mimeType })
  }
  
  //   const fileToBase64 = new Promise((resolve, reject) => {
  //     const reader = new FileReader()
  //     reader.readAsDataURL(newFile)
  //     reader.onload = () => resolve(reader.result)
  //     reader.onerror = error => reject(error)
  //   })
  //   fileToBase64.then((fileURL: any) => {
  //     const body: ConfigBody = {
  //       name: config.name,
  //       description: 'aaaaaa',
  //       script_id: script.id,
  //       file: fileURL.substring(fileURL.lastIndexOf(',') + 1, fileURL.length),
  //     }
  //     dispatch(updateConfig({ scriptId: script.id, configId: config.id, body }))
  //     props.setVisible(false)
  //     dispatch(getConfigs(script.id))
  //   })
  // }
  useEffect(() => {
    urltoFile(`data:application/json;base64,${file}`, 'application/json').then(
      dataFromFile => {
        const read = new FileReader()
        read.readAsBinaryString(dataFromFile)
        read.onloadend = function () {
          setData(read.result as string)
        }
      }
    )
  }, [file])

  useEffect(() => {
    const init = async () => {
      if (props.script) {
        const configFileRes = await dispatch(
          getConfigFile({
            scriptId: props.script,
            configId: selectedConfig.ids[0],
          })
        )
        if (configFileRes?.type.split('/').pop() === 'fulfilled') {
          dispatch(getConfigs(props.script))
          setFile((configFileRes.payload as ConfigFileResponse).file)
        }
      }
    }

    init()
  }, [])
  return (
    <>
      <Editor
        value={data}
        onValueChange={() => null}
        highlight={(data: string) => highlight(data, languages.js, 'js')}
        padding={10}
        style={{
          overflow: 'scroll',
          fontFamily: '"Fira code", "Fira Mono", monospace',
          fontSize: 15,
          backgroundColor: '#FFFFFF',
          height: 900,
        }}
      />
      {/* <div className='submitBtn' id='btn'>
          <Button
            width={120}
            text='Submit'
            type='success'
            stylingMode='contained'
            onClick={submit}
          />
        </div> */}
    </>
  )
}
export default ConfigReview
